import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import ImageProcessor from './pages/ImageProcessor';
import Placeholder from './pages/Placeholder';
import './App.css';

function App() {
  return (
    <Router>
      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/image-processor" element={<ImageProcessor />} />
          <Route path="/placeholder" element={<Placeholder />} />
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App;